/* ============================================
   FORTUNE REALM — MYSPACE ERA JS
   ============================================ */
document.addEventListener('DOMContentLoaded', function() {

  /* --- Logo Sparkle Effect --- */
  var logo = document.querySelector('.logo-text');
  if (logo) {
    var sparkles = ['\u2726', '\u2605', '\u2727', '\u2B50', '\u2736']; // ✦ ★ ✧ ⭐ ✶
    setInterval(function() {
      var s = document.createElement('span');
      s.className = 'logo-sparkle';
      s.textContent = sparkles[Math.floor(Math.random() * sparkles.length)];
      s.style.left = Math.random() * 100 + '%';
      s.style.top = Math.random() * 100 + '%';
      s.style.animationDuration = (0.6 + Math.random() * 0.6) + 's';
      logo.appendChild(s);
      setTimeout(function() { s.remove(); }, 1200);
    }, 400);
  }

  /* --- Banner Carousel --- */
  var track = document.getElementById('carousel-track');
  var viewport = document.getElementById('carousel-viewport');
  var prevBtn = document.getElementById('carousel-prev');
  var nextBtn = document.getElementById('carousel-next');
  var dotsContainer = document.getElementById('carousel-dots');

  if (track && viewport) {
    var slides = track.querySelectorAll('.carousel-slide');
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.carousel-dot') : [];
    var current = 0;
    var total = slides.length;
    var dragging = false;
    var startX = 0;
    var diffX = 0;
    var autoTimer;

    function goTo(i) {
      current = ((i % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      // Update dots
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('active', d === current);
      }
      resetAutoAdvance();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function resetAutoAdvance() {
      clearInterval(autoTimer);
      autoTimer = setInterval(next, 5000);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Dot clicks
    for (var i = 0; i < dots.length; i++) {
      (function(idx) {
        dots[idx].addEventListener('click', function() { goTo(idx); });
      })(i);
    }

    // Touch/mouse swipe
    function onStart(e) {
      dragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      diffX = 0;
    }
    function onMove(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      diffX = x - startX;
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      if (diffX > 50) prev();
      else if (diffX < -50) next();
    }

    viewport.addEventListener('touchstart', onStart, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: true });
    viewport.addEventListener('touchend', onEnd);
    viewport.addEventListener('mousedown', onStart);
    viewport.addEventListener('mousemove', onMove);
    viewport.addEventListener('mouseup', onEnd);
    viewport.addEventListener('mouseleave', onEnd);

    // Start auto-advance
    resetAutoAdvance();
  }

  /* --- Visitor Counter Increment --- */
  var counterEl = document.getElementById('visitor-count');
  if (counterEl) {
    var stored = localStorage.getItem('fr_visit_count');
    var count = stored ? parseInt(stored) + 1 : 48291;
    localStorage.setItem('fr_visit_count', count);
    counterEl.textContent = count.toLocaleString().padStart(7, '0');
  }

  /* --- Cart Drawer --- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-drawer-overlay');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtn = document.getElementById('cart-drawer-close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(function(btn) { btn.addEventListener('click', function(e) { e.preventDefault(); openCart(); }); });
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* --- AJAX Add to Cart --- */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.textContent = 'adding...'; btn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function() {
          updateCartDrawer();
          openCart();
          if (btn) {
            btn.textContent = 'added!';
            setTimeout(function() { btn.textContent = 'add to cart'; btn.disabled = false; }, 1500);
          }
        })
        .catch(function() {
          if (btn) {
            btn.textContent = 'error :(';
            setTimeout(function() { btn.textContent = 'add to cart'; btn.disabled = false; }, 1500);
          }
        });
    });
  });

  /* --- Update Cart Drawer --- */
  function updateCartDrawer() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
      var subtotalEl = document.getElementById('cart-subtotal-amount');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      var itemsEl = document.getElementById('cart-drawer-items');
      if (!itemsEl) return;

      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="cart-empty">your cart is empty</div>';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        html += '<div class="cart-item">';
        html += '<div class="cart-item-image">';
        if (item.image) html += '<img src="' + sizedImg(item.image, '160x') + '" alt="' + escHtml(item.title) + '">';
        html += '</div><div class="cart-item-info">';
        html += '<div class="cart-item-title">' + escHtml(item.product_title) + '</div>';
        if (item.variant_title && item.variant_title !== 'Default Title')
          html += '<div class="cart-item-variant">' + escHtml(item.variant_title) + '</div>';
        html += '<div class="cart-item-price">' + formatMoney(item.final_line_price) + ' x ' + item.quantity + '</div>';
        html += '<button class="cart-item-remove" onclick="removeCartItem(\'' + item.key + '\')">remove</button>';
        html += '</div></div>';
      });
      itemsEl.innerHTML = html;

      var footer = document.querySelector('.cart-drawer-footer');
      if (footer) {
        var checkoutBtn = footer.querySelector('.btn-primary');
        if (checkoutBtn) checkoutBtn.style.display = cart.items.length > 0 ? 'block' : 'none';
      }
    });
  }

  window.removeCartItem = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function() { updateCartDrawer(); });
  };

  /* --- Quantity Buttons --- */
  document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var val = Math.max(1, (parseInt(input.value) || 1) + parseInt(btn.getAttribute('data-qty-change')));
      input.value = val;
    });
  });

  /* --- Product Thumbnails --- */
  document.querySelectorAll('.product-thumbnails button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var src = btn.getAttribute('data-image');
      var main = document.querySelector('.product-gallery .main-image img');
      if (main && src) {
        main.src = src;
        document.querySelectorAll('.product-thumbnails button').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
      }
    });
  });

  /* --- Mobile Menu --- */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var nav = document.querySelector('.header-nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('mobile-active');
      menuToggle.textContent = nav.classList.contains('mobile-active') ? '\u2715' : '\u2630';
    });
  }

  /* --- Music Player Widget (fake toggle) --- */
  var playBtn = document.querySelector('.music-player-widget .play-btn');
  if (playBtn) {
    var playing = false;
    playBtn.addEventListener('click', function() {
      playing = !playing;
      playBtn.innerHTML = playing ? '&#9646;&#9646;' : '&#9654;';
    });
  }

  /* --- Helpers --- */
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function sizedImg(src, size) {
    var m = src.match(/\.(jpg|jpeg|gif|png|bmp|tiff|tif|webp)(\?v=\d+)?$/i);
    if (m) return src.split(m[0])[0] + '_' + size + '.' + m[1] + (m[2] || '');
    return src;
  }
  function escHtml(s) {
    var d = document.createElement('div'); d.textContent = s; return d.innerHTML;
  }
});
